export enum chartsActionTypes {
  SET_LOADING = 'charts/setLoading',
}
